import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import SignupController from './signup.controller';
import SignupSuccess from './signup-success';
import styles from './styles/signup.module.scss';
import SplitLayout from '../common/layouts/splitLayout/SplitLayout';
import { Button, ButtonSizes, Text, Input, InputSizes } from '@clockout-dev/design-elements';
import { PhoneOutlined } from '@ant-design/icons';
import SignupSide from './elements/SignupSide';
import { SplitLayoutSide } from '../common/layouts/splitLayout/splitLayout.constants';
import SigninRedirect from '../common/signInRedirect/SignInRedirect';

/**
 * @extends SignupController
 * @extends Component
 */
class Signup extends Inherit(SignupController, Component) {
    state = {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        phoneNumber: '',
        password: '',
        loading: false,
        error: false,
        showSuccessScreen: false
    };

    render() {
        const { firstName, lastName, email, companyName, phoneNumber, password, error, loading, showSuccessScreen } = this.state;

        // Check if all required fields (except phone) are filled
        const isFormValid = firstName && lastName && email && companyName && password;

        if (showSuccessScreen) {
            return <SignupSuccess />;
        }

        return (
            <SplitLayout
                sideVariant={SplitLayoutSide.LEFT}
                side={<SignupSide />}
                contentClassName={styles.signUpContentContainer}
                sideClassName={styles.signupSideColumn}
            >
                {this.props.notificationContextHolder}
                    <SigninRedirect loading={loading} navigateLogin={this.navigateLogin} />
                    <div className={styles.signupForm}>
                        <Text as="h1" size="display-m" className={styles.formTitle}>Create an account</Text>
                        <div className={styles.nameRow}>
                            <Input
                                size={InputSizes.LARGE}
                                label="First name"
                                id="firstName"
                                value={firstName || ''}
                                onChange={(e) => this.setFirstName(e.target.value)}
                                placeholder="name"
                                status={error ? 'error' : ''}
                                className={styles.input}
                                classNames={{label: styles.inputLabel}}
                            />
                            <Input
                                size={InputSizes.LARGE}
                                label="Last name"
                                id="lastName"
                                value={lastName || ''}
                                onChange={(e) => this.setLastName(e.target.value)}
                                placeholder="name"
                                status={error ? 'error' : ''}
                                className={styles.input}
                                classNames={{label: styles.inputLabel}}
                            />
                        </div>
                        <Input
                            size={InputSizes.LARGE}
                            id="email"
                            label="Email"
                            disabled={true}
                            type="email"
                            value={email || ''}
                            onChange={(e) => this.setEmail(e.target.value)}
                            placeholder="email"
                            status={error ? 'error' : ''}
                            className={styles.input}  
                            classNames={{label: styles.inputLabel}}
                        />
                        <Input
                            size={InputSizes.LARGE}
                            id="companyName"
                            label="Company name"
                            disabled={true}
                            value={companyName || ''}
                            onChange={(e) => this.setCompanyName(e.target.value)}
                            placeholder="company name"
                            status={error ? 'error' : ''}
                            className={styles.input}
                            classNames={{label: styles.inputLabel}}
                        />
                        <Input
                            size={InputSizes.LARGE}
                            id="phoneNumber"
                            label="Phone number"
                            prefix={<PhoneOutlined className={styles.inputIcon} />}
                            value={phoneNumber || ''}
                            onChange={(e) => this.setPhoneNumber(e.target.value)}
                            placeholder="phone number"
                            status={error ? 'error' : ''}
                            classNames={{label: styles.inputLabel}}
                        />
                        <Input.Password
                            size={InputSizes.LARGE}
                            id="password"
                            label="Password"
                            value={password || ''}
                            onChange={(e) => this.setPassword(e.target.value)}
                            placeholder="password"
                            status={error ? 'error' : ''}
                            classNames={{label: styles.inputLabel}}
                        />
                        <Button
                            type="button"
                            size={ButtonSizes.MEDIUM}
                            loading={loading}
                            onClick={() => this.createAccount()}
                            className={styles.continueButton}
                            disabled={!isFormValid}
                            block
                        >
                            Continue
                        </Button>
                    </div>
            </SplitLayout>
        );
    }
}

export default withHooks(Signup);

